module.exports = __webpack_public_path__ + "img/Web.30bd5e47.svg";